import type {
	CreateOneShopExportModelDto,
	ShopDto,
} from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

type UseAddExportModelParams = {
	onSuccess?: () => void;
};

export default function useAddExportModel(
	shop: ShopDto,
	params?: UseAddExportModelParams,
) {
	return useApiMutation("post", "/shops/{shopId}/export-models", {
		invalidate: useInvalidateShop(shop.id),
		onSuccess: params?.onSuccess,
		mapVariables: (exportModel: CreateOneShopExportModelDto) => {
			if (!shop) throw new Error("Shop not found");
			return {
				params: { path: { shopId: shop.id } },
				body: exportModel,
			};
		},
	});
}
